import { useMemo } from 'react'
import { format } from 'date-fns'
import { Column } from 'react-table'
import { BasicTable } from 'components/BasicTable'
import { useContent } from 'lib/content/react'
import { NetworkMerchant } from 'types/entities'

export type NetworkMerchantsTableProps = {
  merchants?: NetworkMerchant[]
}

export const NetworkMerchantsTable = ({
  merchants = [],
}: NetworkMerchantsTableProps) => {
  const { formatMessage } = useContent()
  const columns = useMemo<Column<NetworkMerchant>[]>(
    () => [
      {
        accessor: 'name',
        Header: formatMessage({ id: 'pmportal.restaurantLists.restaurant' }),
      },
      {
        accessor: 'address',
        Header: formatMessage({ id: 'pmportal.restaurantLists.address' }),
      },
      {
        id: 'dateAdded',
        accessor: ({ dateAdded }) =>
          dateAdded ? format(dateAdded, 'dd/LL/yy') : '-',
        Header: formatMessage({ id: 'pmportal.restaurantLists.dateAdded' }),
      },
    ],
    [formatMessage]
  )
  return (
    <BasicTable
      columns={columns}
      data={merchants}
      placeholder={formatMessage({
        id: 'pmportal.restaurantLists.noRestaurantsAdded',
      })}
    />
  )
}
